import { slugify } from "@lib/util/slugify"

const normalizePathSegment = (value: unknown): string => {
  if (typeof value !== "string") return ""
  const normalized = value.trim()
  if (!normalized || normalized.includes("/") || normalized.includes("\\")) {
    return ""
  }
  return normalized
}

export const resolveProductHref = (
  product: {
    slug?: unknown
    brand?: { slug?: unknown; name?: unknown } | null
  },
  fallbackBrand?: { slug?: unknown; name?: unknown } | null
): string => {
  const productSlug = normalizePathSegment(product?.slug)
  if (!productSlug) return "/products"

  const explicitBrandSlug =
    normalizePathSegment(product?.brand?.slug) ||
    normalizePathSegment(fallbackBrand?.slug)
  const brandName =
    normalizePathSegment(product?.brand?.name) ||
    normalizePathSegment(fallbackBrand?.name)
  const brandSlug =
    explicitBrandSlug || (brandName ? slugify(brandName) : "")

  return brandSlug
    ? `/${encodeURIComponent(brandSlug)}/products/${encodeURIComponent(productSlug)}`
    : `/products/${encodeURIComponent(productSlug)}`
}
